// app/javascript/widget/automation.ts — признаки автоматизации браузера.
//
// Тот же детектор, что у лендинга (app/javascript/lib/automation.js), но свой:
// виджет — отдельный бандл, который живёт на ЧУЖИХ сайтах, и тянуть за собой
// код приложения он не должен.
//
// Сигналов ровно два, и оба высокой достоверности: флаг WebDriver и
// подключённая CDP-сессия. Набор намеренно скупой — гейт стоит на пути целей
// (site_chat_* уходят в счётчик клиента и участвуют в ставках Директа), а
// ложное срабатывание стоит живой конверсии в отчёте.

/** Окно с признаками автоматизации — своя форма, чтобы не тянуть DOM-типы. */
interface AutomationWindow {
  navigator?: { webdriver?: boolean };
  console?: { debug?: (value: unknown) => void };
}

// Проверяем один раз на документ: CDP-проба дёргает console.debug, гонять её
// на каждую цель незачем.
let cached: boolean | null = null;

/** @param win окно (в тестах — заглушка). */
export function automationDetected(win: AutomationWindow = window): boolean {
  if (cached === null) cached = webDriverFlag(win) || cdpAttached(win);
  return cached;
}

/** Только для тестов: сбросить закешированный вердикт. */
export function resetAutomationCache(): void {
  cached = null;
}

function webDriverFlag(win: AutomationWindow): boolean {
  return win.navigator?.webdriver === true;
}

// CDP (Chrome DevTools Protocol) — сильнейший признак Playwright/Puppeteer и
// расширений, ездящих через отладчик. Когда домен Runtime подключён, бэкенд
// сериализует отданный в консоль объект и читает его геттеры. Передаём
// console.debug ошибку с геттером `stack`, который взводит флаг: сработал —
// значит консоль слушают на уровне протокола. Сериализация И ЕСТЬ проба, это
// не лог для человека.
function cdpAttached(win: AutomationWindow): boolean {
  const debug = win.console?.debug;
  if (typeof debug !== 'function') return false;

  let detected = false;
  const probe = new Error();
  Object.defineProperty(probe, 'stack', {
    configurable: true,
    get() {
      detected = true;
      return '';
    },
  });
  debug.call(win.console, probe);
  return detected;
}
